<template>
    <span class="DeleteIconRequest">
        <font-awesome-icon :icon="['fa', 'trash-alt']" @click="ButtonClick" class="pointer red " style="font-size: 20px;margin-right:1rem;" />
        <b-modal ref="component-modal" title="CONFIRM ACTION" hide-footer>
            <b-container>
                <b-form @submit="Save">
                    <b-row>
                        {{ ConfirmationString }}
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="Cancel()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="primary" @click="Save()">
                                CONFIRM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
    </span>

</template>

<script>

    import { EventBus } from '../../../services/event-bus.js';
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    export default {
        props: [
            "RequiresConfirmation",
            "ConfirmationString",
            "Endpoint",
            "Payload",
            "PerformGlobalUpdate",
            "ChartId",
            "Method"
        ],
        data: function () {
            return {

            };
        },
        methods: {
            ShowModal() {
                this.$refs['component-modal'].show();
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            ButtonClick() {
                if (this.RequiresConfirmation) {
                    this.ShowModal()
                } else {
                    this.Save();
                }
            },
            Save() {
                if (this.Method) {
                    this.$MasterAPI.ExecuteRequest(this.Method, this.Endpoint, this.Payload, this.SaveSuccess, () => { }, true);
                } else {
                    this.$MasterAPI.ExecuteRequest("POST", this.Endpoint, this.Payload, this.SaveSuccess, () => { }, true);
                }
                
        },
        SaveSuccess(response) {
            let vm = this;
            vm.$refs['component-modal'].hide();
            //emit success response
            vm.$emit("success");
            //Perform Global Updates
            if (vm.PerformGlobalUpdate) {
                vm.$GlobalUpdate.ExecuteGlobalUpdate(vm.ChartId);
            }
        },
            HandleShown() {
                this.$refs.showfocus.focus();
            }
        },
        components: {

        },
        computed: {

        }
    }
</script>

<style scoped>
</style>